// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".alarm-form .k-form-item{width:100%}.alarm-form .k-input{width:85%}.alarm-form .k-select{width:85%}", "",{"version":3,"sources":["webpack://src/static/styles/alarmform.styl"],"names":[],"mappings":"AACE,yBACA,UAAO,CAEP,qBACE,SAAO,CAET,sBACE,SAAO","sourcesContent":[".alarm-form {\n  .k-form-item {\n  width: 100%;\n  }\n  .k-input {\n    width: 85%\n    }\n  .k-select {\n    width: 85%\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
